<template>
  <div class="response-tabs-team">
    <div v-if="loading"></div>
    <div v-else-if="!error">
      <template v-if="members">
        <MemberItem v-for="(member, index) in members" :key="index" 
          :index="index + 1"
          :isTeamLeader="index === 0"
          :item="member"
        />
      </template>
    </div>
    <div v-else-if="error" class="error">
      {{ $tr('common.errrorLoadingPageContent') }}
    </div>
  </div>
</template>

<script>
import MemberItem from './MemberItem.vue'

import MixinState from '../../../mixins/state.js'

export default {
  name: 'response-tabs-team',

  props: {
    response: Object
  },

  components: {
    MemberItem
  },

  mixins: [
    MixinState
  ],

  computed: {
    blocksHidden () {
      return this.$store.getters['response/blockHidden']
    },

    loading () {
      return this.storeResponse.loading
    },

    error () {
      return this.storeResponse.error
    },

    members () {
      return this.storeResponseDataBatChampionship ? this.storeResponseDataBatChampionship.members : null
    }
  },

  methods: {
    fetch () {
      this.$store.dispatch('process/batChampionship/response/fetch', this.response)
    }
  },

  beforeMount () {
    // do not fetch here, because the request for bat data have been send from root process component (SceneProcess.vue)
    // this.fetch()
  }
}
</script>


<style lang="scss" scoped>
  @import '../../../../../styles/colors.scss';
  .response-tabs-team{
    padding-top: 20px;
    padding-left: 12px;
  }
</style>
